import HttpClientRepository from './HttpClientRepository';

export const httpClient = new HttpClientRepository();
export { HttpClientRepository };
